import classNames from 'classnames'
import { ReactNode } from 'react'

import { MODAL_WRAPPER_X_PADDING } from '@apps-common/components/modals/modal/ModalContainer'

interface IProps {
  children: ReactNode
  classes?: string
}

export const ModalBody: React.FC<IProps> = ({ children, classes }) => (
  <div
    className={classNames(
      classes,
      MODAL_WRAPPER_X_PADDING,
      'w-full h-[100%] overflow-y-auto !overscroll-none scrollbar-none pb-[calc(96px+max(env(safe-area-inset-bottom),0px))] sm:pb-[80px]'
    )}
  >
    {children}
  </div>
)
